import axios from "axios";
import { getToken } from "../util/localStorage";
import { updateUserData } from "../ducks/Login";
import refreshAccessToken from "../services/refreshAccessToken";
import { store } from "../store";

let apiVersion = process.env.REACT_APP_API_BASE_URL;
  const instance = axios.create({
    baseURL: apiVersion,
    withCredentials: true,
    headers: { 'Content-Type': 'application/json', 'charset': 'utf-8', "ngrok-skip-browser-warning": true }
  })
  instance.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
instance.interceptors.request.use(
  (config) => {
    const token = getToken();
    config.headers.pageURL = window.location.href;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

let isAlreadyFetchingAccessToken = false;
let requests = [];
let refreshAttempts = 0;
const MAX_REFRESH_ATTEMPTS = 3;

const onAccessTokenFetched = (access_token) => {
  requests = requests.filter((callback) => callback(access_token));
};

const addRequest = (callback) => {
  requests.push(callback);
};

instance.interceptors.response.use(
  (response) => {
    refreshAttempts = 0; // Reset on successful response
    return response;
  },
  (error) => {
    const status = error?.response?.status;
    const originalRequest = error?.config;
    const { email } = store.getState().auth;
    
    if (status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      
      // Prevent infinite refresh loops
      if (refreshAttempts >= MAX_REFRESH_ATTEMPTS) {
        if (window.location.pathname !== '/lmiiwatta' && !window.location.pathname.includes('/logout')) {
          window.location.href = "/logout";
        }
        return Promise.reject(error);
      }
      
      if (!isAlreadyFetchingAccessToken) {
        isAlreadyFetchingAccessToken = true;
        refreshAttempts++;
        
        return refreshAccessToken()
          .then((res) => {
            let {
              token,
              refreshToken,
              loginId,
              contactId,
              clientId,
              instrId,
              fullName,
              webRole,
              agencyInstrId,
              chatEmail,
              showTrainerRole
            } = res.data;
            
            const loginReducerData = {
              email: email,
              token: token,
              refreshToken: refreshToken,
              auth: true,
              loginId: loginId,
              contactId: contactId,
              clientId: clientId,
              instrId: instrId,
              fullName: fullName,
              webRole: webRole,
              agencyInstrId: agencyInstrId,
              chatEmail: chatEmail,
              showTrainerRole: showTrainerRole
            };
            
            const action = updateUserData(loginReducerData);
            store.dispatch(action);
            isAlreadyFetchingAccessToken = false;
            refreshAttempts = 0; // Reset on successful refresh
            onAccessTokenFetched(token);
            
            // Retry the original request with new token
            originalRequest.headers.Authorization = `Bearer ${token}`;
            return instance.request(originalRequest);
          })
          .catch((refreshError) => {
            isAlreadyFetchingAccessToken = false;
            
            // Clear any pending requests
            requests = [];
            
            console.error('Token refresh failed:', refreshError);
            
            // Don't logout if we're already on the logout page or impersonation page
            if (window.location.pathname === '/lmiiwatta' || window.location.pathname.includes('/logout')) {
              return Promise.reject(error);
            }
            
            // Only redirect to logout if refresh token is actually invalid or we've hit max attempts
            if (refreshError?.response?.status === 401 || 
                refreshError?.response?.status === 400 || 
                refreshAttempts >= MAX_REFRESH_ATTEMPTS ||
                refreshError?.message === 'No tokens available for refresh') {
              window.location.href = "/logout";
            }
            
            return Promise.reject(error);
          });
      }
      
      // If we're already fetching a token, queue this request
      const retryOriginalRequest = new Promise((resolve, reject) => {
        addRequest((access_token) => {
          if (access_token) {
            originalRequest.headers.Authorization = "Bearer " + access_token;
            resolve(instance.request(originalRequest));
          } else {
            reject(error);
          }
        });
      });
      
      return retryOriginalRequest;
    }
    
    return Promise.reject(error);
  }
);

export default instance;
